<ul class="facet-groups-list">
    <li *ngFor="let facetGroup of facetGroups" class="facet-group">
        <finder-font-icon
            class="facet-icon"
            size="s"
            [name]="facetGroup.icon">
        </finder-font-icon>
        <ul class="facets-list">
            <li *ngFor="let facet of facetGroup.facets" class="facet">
                @if (entityTypeUrl && facet?.isClickable) {
                    <finder-anchor
                        class="facet-link"
                        [href]="facet?.url"
                    >{{ facet.name }}</finder-anchor>
                } @else {
                    {{ facet.name }}
                }
            </li>
        </ul>
    </li>
</ul>
